import styled from 'styled-components'

import Toolbar from '@/components/Toolbar/Toolbar'

export const TabsActionsBar = styled(Toolbar)`
	display: flex;
	border-bottom: 1px solid #ddd;
`
